import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from '@reducers';

const composeEnhancers =
    (import.meta.env.MODE === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const appReducer = (state, action) => {
    if (action.type === 'CLEAR_STORE') {
        return rootReducer(undefined, action);
    }
    return rootReducer(state, action);
};

export const store = createStore(appReducer, composeEnhancers(applyMiddleware(thunk)));
